<template>
    <div style="background: #FAFAFA;">
        <div class="container" style="padding-top: 0.5rem; padding-bottom: 3rem;">


            <div class="previous-challenges-holder">
                <h4 @click="goBack()">Previous Challenges</h4>

                <div v-if="loading">
                    <PageLoader></PageLoader>
                </div>
                <div v-else class="challenges-list" v-for="item in myChallengesData">
                    <h3>{{item.challenge.title}}</h3>
                    <p>{{ item.challenge.details }}</p>
                    <h6 :class="item.media.length > 0 ? 'submission' : 'no-submission'">
                        <span class="dot"></span>
                       {{ item.media.length > 0 ? 'Submitted' : 'No submission' }}
                    </h6>
                    <!-- no-submission -->
                    <hr>
                    <div class="challenge-footer">
                        <button class="btn" @click="routeTo(`/dashboard/view-challenge/${item.challenge.category_id}/${item.kid_id}`)">View challenge</button>
                        <span>
                            <i class="fa fa-chevron-right" style="color: #2EBFCA;"></i>
                        </span>
                    </div>
                </div>
                <div v-if="myChallengesData.length == 0 && !loading">
                    <EmptyState :emptyData="emptyDataObject" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import EmptyState from "../../components/EmptyState.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "MyChallenge",
    components: {
        PageLoader,
        EmptyState,
    },

    data() {
        return {
            loading: false,
            kidId: null,
            myChallengesData: [],
            emptyDataObject: {
                header: "No Challenge yet",
                option: "Yet to recieve any Challege"
            },
        };
    },
    created() {
        const kidItem = JSON.parse(localStorage.getItem('kidDetails'));
        if (kidItem) {
            this.kidId = kidItem.id;
            // console.log("CoachForm", this.coachForm)
        }
    },
    mounted() {
       this.myChallenges();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        async myChallenges() {
            this.loading = true;
            try {
                await Api.postRequest(`fetch-kid-postings-by-kid-id/${this.kidId}`).then(res => {
                    // console.log("Kid challenges:", res);
                    this.loading = false;
                    if (res.data.success) {
                        this.myChallengesData = res.data.data;
                    }
                }).catch (err => {
                    console.log("Error:", err);
                    this.loading = false;
                })
            } finally {
                // console.log("Closed")
                this.loading = false;
            }
        },
        goBack() {
            this.$router.back();
        },
    }
};
</script>


<style scoped lang="scss">

.previous-challenges-holder {
    h4 {
        font-family: Nunito;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: left;
        margin-bottom: 20px;
    }
}
.challenges-list {
    background: #ffffff;
    padding: 15px;
    border-radius: 20px;
    border: 1px solid #F5F7FA;
    margin-bottom: 15px;
    h3 {    
        font-family: Nunito;
        font-weight: 600;
        font-size: 23px;
        line-height: 24px;
        color: #000000;
        text-align: left;
        white-space: nowrap;

    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
        color: #1C2B3A;
        text-align: left;
    }
    
}

.challenge-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        color: #2EBFCA;
        outline: 0;
        box-shadow: none;
    }
}

.no-submission {
    background: #D1EFFA;
    border-radius: 50px;
    padding: 9px 22px;
    border: 2px solid #FFFFFF;
    box-shadow: 0px 0px 1.4px 3px #5D6F7C0D inset;
    margin-top: 30px;
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    color: #2AB3E6;
    height: 36px;
    width: fit-content;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    .dot {
        width: 10px;
        height: 10px;
        background: #2AB3E6;
        // color: white;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin-right: 8px;
    }
}
.submission {
    background: #CCFFE1;
    border-radius: 50px;
    padding: 9px 22px;
    border: 2px solid #FFFFFF;
    box-shadow: 0px 0px 1.4px 3px #5D6F7C0D inset;
    margin-top: 30px;
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    color: #00C853;
    height: 36px;
    width: fit-content;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    .dot {
        width: 10px;
        height: 10px;
        background: #00C853;
        // color: white;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin-right: 8px;
    }
}


</style>